import { createFileRoute, useParams, useSearch } from "@tanstack/react-router";
import { AgentChatThreadResume } from "@/components/agents/agent-chat-thread-resume";
import { useAgents, useWorkspaceRoot } from "@/lib/api";
import { pickPeekSearch } from "@/lib/peek-search";

export const Route = createFileRoute("/$owner/chat/$agentId")({
	validateSearch: (
		search: Record<string, unknown>,
	): Record<string, string | true | undefined> => {
		const out: Record<string, string | true | undefined> = {};
		if (search.new === true || search.new === "1" || search.new === "true") {
			out.new = true;
		}
		if (typeof search.prompt === "string" && search.prompt.length > 0) {
			out.prompt = search.prompt;
		}
		const messageId =
			(typeof search.message_id === "string" && search.message_id.trim()) ||
			(typeof search.message === "string" && search.message.trim()) ||
			"";
		if (messageId) out.message_id = messageId;
		Object.assign(out, pickPeekSearch(search));
		return out;
	},
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
		void queryClient.prefetchQuery(useAgents.queryOptions(params.owner));
	},
	component: ActivityChatLayout,
});

function ActivityChatLayout() {
	const { owner, agentId } = Route.useParams();
	const { threadId } = useParams({ strict: false }) as { threadId?: string };
	const { new: newChat, prompt } = useSearch({ strict: false }) as {
		new?: true;
		prompt?: string;
	};

	return (
		<div className="flex min-h-0 flex-1 flex-col overflow-hidden px-4 pt-2.5 pb-4 lg:px-6 lg:pb-6">
			<div className="mx-auto flex min-h-0 w-full max-w-3xl flex-1 flex-col">
				<AgentChatThreadResume
					owner={owner}
					agentId={agentId}
					threadId={threadId}
					initialDraft={prompt}
					forceComposer={!threadId}
					newChatRequested={Boolean(newChat)}
				/>
			</div>
		</div>
	);
}
